module.exports = __webpack_public_path__ + "static/media/featured_listing_2.33c80a08.png";